import { ArrowDropDown } from "@mui/icons-material";
import { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { inject } from "../../../../../../../../lib/itn-ui-kit/services/service-container";

export default function ApptBillsActions({
  selectedBills,
  handleOpenAddModal,
  handleOpenDeleteModal,
}) {
  const currentUserService = inject("current-user-service");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const allowActions = Boolean(selectedBills?.length > 0);
  const canEdit = currentUserService?.userRoles?.permissions.includes(
    "provider.change_administeredservices"
  );
  const canDelete = currentUserService?.userRoles?.permissions.includes(
    "provider.delete_administeredservices"
  );

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!canEdit && !canDelete) {
    return null;
  }

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className="flex items-center px-2 py-0 normal-case"
        variant="outlined"
      >
        Actions <ArrowDropDown />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {canEdit && (
          <MenuItem disabled={!allowActions} onClick={handleOpenAddModal}>
            Edit
          </MenuItem>
        )}

        {canDelete && (
          <MenuItem disabled={!allowActions} onClick={handleOpenDeleteModal}>
            Delete
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}
